<template lang="pug">
  .height-100
    h3.title Reporte de vacaciones
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="lista_solicitudes")
        .contenedor-interno
          .title
            span Reporte de vacaciones SAP
            span.icon.close(
              @click="$emit('close')"
            )
              i.fa.fa-close

          transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
            .filtros-container(key="filtros-container")
              transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
                .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
                  h2.text filtros
                  .caret
                    span.icon
                      i.fa.fa-caret-down(v-if="mostrarFiltros")
                      i.fa.fa-caret-up(v-else)
                .filtros(v-if="mostrarFiltros", key="filtros")
                  .filtro
                    .codigo-empleado
                      .control.title-singular
                        p Empleado
                        .input-container
                          input.input(
                            type="number",
                            v-model="filtroCodigoEmpleado"
                            @focus="mostrarBusquedaEmpleado = true"
                            :disabled="true"
                          )
                          span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                            i.fa.fa-search
                          .erase-data(@click="borrarEmpleado")
                            .icon
                              .fa.fa-times
                      transition(name="fade-quick")
                        .pop-over(
                            v-if="mostrarBusquedaEmpleado"
                          )
                            lookup-small-empleado(
                              @selected="seleccionarEmpleado"
                              @close="mostrarBusquedaEmpleado = false"
                              :codigo="filtroCodigoEmpleado"
                              :empleadosInactivos="'all'"
                            )
                  .filtro
                    .lookup
                      .control.title-singular
                        p Tipo de búsqueda
                        .input-container.display-flex
                          select.input(
                            v-model="modoFiltroVacaciones"
                            @change="fetch"
                          )
                            option(value="rango") Por rango de fechas
                            option(value="laboral") Por rango de fechas laborales L-V
                  .filtro
                    .lookup
                      .control.title-singular
                        p Desde
                        .input-container.display-flex
                          input.input(
                            type="date",
                            v-model="desde"
                            @blur="fetch"
                          )
                  .filtro
                    .lookup
                      .control.title-singular
                        p Hasta
                        .input-container.display-flex
                          input.input(
                            type="date",
                            v-model="hasta"
                            @blur="fetch"
                          )
                  //- .filtro
                    .lookup
                      .control.title-singular
                        p ¿Solo Cesados?
                        .input-container.display-flex
                          select.input(
                            v-model="empleadosInactivos"
                            @change="fetch"
                          )
                            option(value="all") Todos
                            option(value="1") Sí
                            option(value="0") No

                .boton-container(key="boton-container")
                  button.button(@click="fetch")
                    span.icon.is-small
                      i.fa.fa-refresh.fa-fw.fa-lg
                    span Refrescar
                  button.button(@click="limpiarFiltros")
                    span.icon.is-small
                      i.fa.fa-trash.fa-fw.fa-lg
                    span Limpiar
                  button.button.margin-button-top(@click="exportarExcel")
                    span.icon.is-small
                      i.fa.fa-file-excel-o.fa-fw.fa-lg
                    span Exportar Excel
                  button.button.margin-button-top(@click="exportarNuevoExcel")
                    span.icon.is-small
                      i.fa.fa-file-excel-o.fa-fw.fa-lg
                    span Exportar Nuevo reporte
            .body(key="body")
              .is-loading(v-if="isLoading")
                .icon
                  i.fa.fa-spinner.fa-spin
              .information(v-else)
                template(v-if="lista.length > 0")
                  .is-desktop
                    table.table.is-striped.is-bordered
                      thead
                        th Empleado
                        th.hide-break-1 Desde
                        th.hide-break-1 Hasta
                        th.show-break-1 Fecha
                        th Dias
                        th Tipo
                        th Motivo
                      tbody(
                        name="table-row"
                        is="transition-group"
                      )
                        tr.row-table(
                          v-for="(o,index) in lista"
                          :key="o+index+''"
                        )
                          td.text-center
                            .hint--top(:aria-label="'Empleado: ' + o.codigoEmpleado")
                              span {{ o.nombreEmpleado }}
                          td.hide-break-1 {{ o.fechaDesde }}
                          td.hide-break-1 {{ o.fechaHasta }}
                          td.show-break-1 {{ o.fechaDesde === o.fechaHasta ? o.fechaDesde : o.fechaDesde + ' ' + o.fechaHasta }}
                          td {{ o.cantidadDeDias }}
                          td {{ o.tipoAlgoritmo }}
                          td {{ o.motivo }}

                  .is-mobile
                    .box(
                      v-for="(o, index) in lista"
                      :key="o+index+''"
                    )
                      .descripcion-tipo.hint--top(:aria-label="'Empleado: ' + o.codigoEmpleado")
                        span.fs-18 {{ o.nombreEmpleado }}
                      .descripcion-tipo
                        span {{ o.tipoAlgoritmo }}
                      .motivo(v-if="o.motivo")
                        div
                          span {{ o.motivo }}
                      .dias-pedidos
                        strong Fecha
                        div
                          span.detalle-dias {{ o.fechaDesde === o.fechaHasta ? o.fechaDesde : o.fechaDesde + ' - ' + o.fechaHasta }} |
                            strong &nbsp;{{ o.cantidadDeDias }} dias
                div(v-else)
                  .message.is-warning
                    .message-body No hay informacion que cumplan con los siguientes filtros
</template>

<script>
import LookupSmallEmpleado from '../components/Component_Lookup_Small_Empleado'
import { apiGet, apiGetExcel, notify } from '../util/general'
import moment from 'moment'
export default {
  name: 'reporte_vacaciones_component',
  data () {
    return {
      lista                       : [],
      isLoading                   : false,
      mostrarBusquedaEmpleado     : false,
      mostrarFiltros              : true,
      mostrarConfirmacionNoLoTomo : false,
      solicitudSeleccionada       : {},
      filtroCodigoEmpleado        : '',
      desde                       : moment().startOf('month').format('YYYY-MM-DD'),
      hasta                       : moment().endOf('month').format('YYYY-MM-DD'),
      empleadosInactivos          : 'all',
      modoFiltroVacaciones        : 'rango' // rango | laboral
    }
  },
  components: {
    LookupSmallEmpleado
  },
  created () {
    this.limpiarFiltros()
    this.fetch()
  },
  methods: {
    borrarEmpleado () {
      this.filtroCodigoEmpleado = ''
      this.fetch()
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
      this.fetch()
    },
    fetch () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true

      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        desde          : vm.desde,
        hasta          : vm.hasta,
        empleadosInactivos      : vm.empleadosInactivos,
        modoFiltroVacaciones  : vm.modoFiltroVacaciones
      }

      apiGet(vm, '/vacaciones/reporte-sap', filtros, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    exportarExcel () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      let obj = {
        desde          : vm.desde,
        hasta          : vm.hasta,
        codigoEmpleado : vm.filtroCodigoEmpleado,
        modoFiltroVacaciones  : vm.modoFiltroVacaciones
      }
      apiGetExcel(vm, '/vacaciones/reporte-sap/excel', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'reporteVacaciones' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    limpiarFiltros () {
      this.filtroCodigoEmpleado = ''
      this.desde = moment().startOf('month').format('YYYY-MM-DD')
      this.hasta = moment().endOf('month').format('YYYY-MM-DD')
      this.fetch()
    },
    exportarNuevoExcel () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      let obj = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        desde          : vm.desde,
        hasta          : vm.hasta,
        modoFiltroVacaciones  : vm.modoFiltroVacaciones
      }
      apiGetExcel(vm, '/vacaciones/empleado/vacacionesNuevoReporte', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'reporteVacacionesEmpleado' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .seen
    background-color: #DA8D7D;
    padding: 0px 4px;
    margin-top: 3px;
    border-radius: 4px;
    color: #fff;
  .fs-18
    font-size 18px
  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px
  .lookup
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px
  .is-bold
    font-weight bold
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        // width 100%
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px




  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;
  .dias-pedidos
    font-size 12px
    color #9a9a9a

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .show-break-1
    display none
  // @media (max-width 560px)
  //   .is-mobile
  //     display block

  //   .is-desktop
  //     display none

  @media (max-width 625px)
    .show-break-1
      display table-cell
    .hide-break-1
      display none

    .td-wrapper
      display flex
      flex-direction column
      justify-content center
      align-items center
  @media(max-width: 530px)
    .filtros
      flex-direction: column;
      .filtro
        width 100%;

  @media(max-width: 500px)
    .is-desktop
      display none
    .is-mobile
      display block
  @media (max-width 399px)
    .boton-container
      .margin-button-top
        margin-top 5px

</style>



// WEBPACK FOOTER //
// View_Reporte_Vacaciones.vue?3aaff2c0